import { MembershipIcon } from "apps/portal/src/components/atoms/icons/MembershipIcon";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { RouteFeature } from "apps/portal/src/routes";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../atoms";
import { HostedPagesProfileCard } from "../../../../components/HostedPagesProfileCard";

export const HostedPagesProfileGetMembership = () => {
  const { t } = useTranslation();
  const { createSiteOrEmbedLink } = usePortalRoutes();

  return (
    <HostedPagesProfileCard.Container className="border-secondary-500 dark:border-secondary-500 relative overflow-hidden">
      <div className="z-20 flex w-full flex-col flex-wrap justify-between gap-3 sm:flex-row">
        <div className="flex flex-col gap-0.5">
          <div className="dark:text-gray-25 text-base font-bold text-gray-950">
            {t(
              "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.title",
            )}
          </div>
          <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
            {t(
              "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.subTitle",
            )}
          </div>
        </div>
        <Button
          className="w-fit px-6 text-sm font-semibold"
          intent="secondary"
          link={createSiteOrEmbedLink(
            RouteFeature.SiteBuyMembershipType.replace(
              ":membershipType",
              "all",
            ),
          )}
        >
          {t(
            "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetMembership.button",
          )}
        </Button>
      </div>
      <MembershipIcon
        className="absolute -right-7 top-0 z-10 block h-[7.75rem] sm:hidden"
        pathClassName="stroke-secondary-25 dark:stroke-secondary-800"
      />
    </HostedPagesProfileCard.Container>
  );
};
